import { connect } from 'react-redux';
import SupportingDocs from './SupportingDocumentsComponent';
import {
  getRequiredDocuments,
  getOptionalDocuments,
  getEitherOrDocuments,
  getApplicationDocuments,
  getApplicationDocumentsMap,
  getError,
} from '../../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../../state/actions/ApplicationActions';
import { getLanguage } from '../../../../state/reducers/AppReducer';
import { getConfig } from '../../../../state/reducers/ConfigReducer';

const mapStateToProps = state => {
  const { pictureFileTypes, fileTypes } = getConfig(state);
  return {
    requiredDocuments: getRequiredDocuments(state) || [],
    optionalDocuments: getOptionalDocuments(state) || [],
    eitherOrDocuments: getEitherOrDocuments(state) || [],
    documents: getApplicationDocuments(state) || [],
    documentMap: getApplicationDocumentsMap(state) || {},
    pictureFileTypes: pictureFileTypes || 'JPG, JPEG, PNG, TIFF, BMP',
    fileTypes: fileTypes || 'JPG, JPEG, PNG, TIFF, BMP',
    lang: getLanguage(state),
    error: getError(state),
  };
};

const {
  uploadRequest,
  uploadFailure,
  deleteDocumentRequest,
} = ApplicationActions;

export default connect(mapStateToProps, {
  upload: uploadRequest,
  uploadFailure,
  deleteDocumentRequest,
})(SupportingDocs);



// WEBPACK FOOTER //
// ./src/view/forms/Application/SupportingDocuments/index.js